import { PRIMARY_COLOR } from "../_const/color.const";
import { theme } from "./theme.styles";


export const useDrawerStyles = {
    root: {
        "& .MuiDrawer-paper": {
            width: "75%",
            maxWidth: "500px",
            overflowX: "hidden",
            "&.MuiDrawer-paperAnchorRight .heading h4": {
                fontSize: '22px',
                fontFamily: 'Helvetica',
                fontWeight: '50 !important',
                fontStyle: 'normal !important'
            }

        },
    },
    header: {
        backgroundColor: PRIMARY_COLOR[0],
        color: "white",
        height: "64px",
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1
    },
    container: {
        // padding: 1
    }
};